import { useState, useMemo } from "react"
import {Card,Descriptions,Row,Avatar,Typography,Space} from "antd"
import { 
    TwitterOutlined,
    FacebookOutlined,
    WhatsAppOutlined,
    InstagramOutlined,
  } from "@ant-design/icons";
import {convertDateToOnlyDate,convertDateToTime} from "../../../utils/TranformDate"
import { useLocation,useHistory } from "react-router-dom"

const {Meta}=Card
const {Text} = Typography;

export default function InstituteCoordinator(props) {
    const {Body:Institute,DefaultProfile}=props
    const [coordinatorInstituteRol,setCoordinatorInstituteRol]=useState([]);
    const [coordinatorInstituteContact,setCoordinatorInstituteContact]=useState([]);
    const Coordinator=Institute?.User
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );
    useState(()=>{
        setCoordinatorInstituteRol(Institute?.User?.SystemRol);
        setCoordinatorInstituteContact(Institute?.User?.Contact);
        if (searchParams.get('option')!=="CoordinatorData") {
            searchParams.set('option', 'CoordinatorData');
            history.replace({ search: searchParams.toString() });
        }
    },[])
    return(
    <>
        <Card 
        bordered={false}
        bodyStyle={{backgroundColor:"whitesmoke"}}
        >
            {/* <Row style={{padding:10}} align={"center"}>
                <Col span={4} >
                    <Card bordered={false}>
                        <Image  ></Image>
                    </Card>
                </Col>
                {/* <Col span={8} offset={12}>
                    <Card bordered={false}>
                        <Image src={logoCenter}></Image>
                    </Card>
                </Col>
            </Row>*/}
            <Row>
                <Card 
                headStyle={{textAlign: "center"}}
                style={{width:"100%"}} 
                bordered={false}
                >
                    <Card>
                    <Meta
                    avatar={<Avatar shape="square" src={DefaultProfile}/>}
                    title={`Coordinador del ${Institute.acronym}`}
                    description={`Datos propios del coordinador`}
                    ></Meta>
                    </Card>
                    <Descriptions   
                    bordered={true}
                    >
                        {console.log("coordinatorInstituteRol",coordinatorInstituteRol)}
                        {console.log("Institute",Institute)}
                        <Descriptions.Item label="Nombres" span={3} >{Coordinator?.firstName} </Descriptions.Item >
                        <Descriptions.Item label="Apellidos" span={3}>{Coordinator?.lastName}</Descriptions.Item>
                        <Descriptions.Item label="Rol" span={3}>{coordinatorInstituteRol?.name}</Descriptions.Item>
                        <Descriptions.Item label="Correo electornico" span={3}>{Coordinator?.email}</Descriptions.Item>
                        <Descriptions.Item label="Fecha de nacimiento"span={3}>{convertDateToOnlyDate(Coordinator?.birthDate)}</Descriptions.Item>
                        <Descriptions.Item label="Numero de celular"span={3}>{coordinatorInstituteContact?.cellPhone}</Descriptions.Item>
                        <Descriptions.Item label="Numero de telefono"span={3}>{coordinatorInstituteContact?.phone}</Descriptions.Item>
                        <Descriptions.Item label="Numero de pasaporte"span={3}>{coordinatorInstituteContact?.passport}</Descriptions.Item>
                        <Descriptions.Item label="Carnet de identidad"span={3}>{coordinatorInstituteContact?.userCI}</Descriptions.Item>
                        <Descriptions.Item label="Pais de origen"span={3}>{coordinatorInstituteContact?.ubication}</Descriptions.Item>
                        <Descriptions.Item label="Redes sociales"span={3}>
                            <Space direction="vertical">
                                <Text> <FacebookOutlined /> {coordinatorInstituteContact?.socialNetworks?.facebook}</Text>

                                <Text> <WhatsAppOutlined /> {coordinatorInstituteContact?.socialNetworks?.whatsapp}</Text>

                                <Text>  <InstagramOutlined /> {coordinatorInstituteContact?.socialNetworks?.instagram}</Text>

                                <Text> <TwitterOutlined />  {coordinatorInstituteContact?.socialNetworks?.twitter }</Text>
                            </Space>
                        </Descriptions.Item>
                        <Descriptions.Item label="Fecha de creacion"span={3}>{convertDateToOnlyDate(Coordinator?.createdAt)}</Descriptions.Item>
                        <Descriptions.Item label="Hora de creacion"span={3}>{convertDateToTime(Coordinator?.createdAt)}</Descriptions.Item>
                        <Descriptions.Item label="Fecha de actualización"span={3}>{convertDateToOnlyDate(Coordinator?.updatedAt)}</Descriptions.Item>
                        <Descriptions.Item label="Hora de actualización"span={3}>{convertDateToTime(Coordinator?.createdAt)}</Descriptions.Item>
                    </Descriptions>
                 </Card>
            </Row>
        </Card>
    </>
    )
    
}